import { MapBoxSkeleton, MapTitleSkeleton, StyledMapSkeleton } from './styles';

export const MapSkeleton = () => (
  <StyledMapSkeleton data-testid="map-skeleton">
    <MapTitleSkeleton />
    <MapBoxSkeleton />
  </StyledMapSkeleton>
);
